<template>
  <div class="visualizer-container">
    <div class="visua-center" ref="center">
      <template
        v-if="
          status === statusMap.connecting || status === statusMap.disconnect
        "
      >
        <div class="visua-guide">
          <div class="visua-gif"></div>
          <div class="guide-banner">{{ connectMessage || "打开应用，轻扇三下" }}</div>
          <div class="guide-tip" style="display: none">
            可视化事件定义需要诸葛io IOS SDK 2.0 以上版本。
            <a
              href="https://sdk.zhugeio.com/Zhuge_iOS_SDK.zip"
            >(下载)</a>
          </div>
        </div>
      </template>
      <template v-if="status === statusMap.connected">
        <ul class="visua-log" ref="toLogs">
          <transition name="fade" v-for="(item) in debugLogs" :key="item.id">
            <li>
              <span class="zg_icons icon_hand"></span>
              {{ item.name }}
            </li>
          </transition>
        </ul>
        <div class="visua-scene" :style="sceneStyle" ref="scene">
          <img :src="bgImgSrc" :width="sceneRect.width" :height="sceneRect.height" />
          <canvas
            ref="canvas"
            :width="sceneRect.width"
            :height="sceneRect.height"
            :style="{ left: sceneRect.width + 'px', border: '1px solid red' }"
          ></canvas>
          <div class="tree-container">
            <div
              :class="{
                'clickable-ele': true,
                'visua-checked': existEventIds.includes(item.element.orderIndex)
              }"
              v-for="item in clickableElements"
              :key="item.element.hashCode"
              :style="item.style"
              @click="onClickElement(item.element)"
            ></div>
          </div>
        </div>
      </template>
    </div>
    <event-list @bindEvents="sendMsg"></event-list>
    <c-dialog
      title="添加事件"
      v-if="showAddDialog"
      class="visua-add-dialog"
      enableLoading
      ref="addDialog"
      @confirm="onAddEvent"
      @cancel="showAddDialog = false"
    >
      <label>事件名称:</label>
      <c-input
        :width="270"
        v-model="eventName"
        autofocus
        :autoValid="false"
        :message="nameTip"
        :validator="nameValidator"
        ref="eventName"
      ></c-input>
    </c-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import EventList from "./eventList";
import dataHandle from "./dataHandle";
import { util, md5 } from "../../utils";
import { actions } from "../../store/constants";

let socket = null;
export default {
  name: "androidVisualizer",
  components: {
    EventList
  },
  props: {
    socketUrl: {
      type: String,
      default: 'wss://codeless.zhugeio.com/connect'
    }
  },
  data() {
    return {
      rootPanel: null,
      logInterval: null,
      statusMap: {
        connected: 1, // 已连接
        connecting: 2, // 连接中
        disconnect: 3 // 未连接
      },
      status: 3,
      connectMessage: "",
      preHash: "", // 截图的hash，避免重复渲染用的
      deviceInfo: null,
      snapshotInterval: null, // 截屏请求轮询
      bgImgSrc: "",
      scale: 1, // 缩放比例
      sceneRect: {
        width: 100,
        height: 100
      },
      debugLogs: [],
      // 可点击元素
      clickableElements: [],
      showAddDialog: false,
      eventName: "",
      nameTip: "", // 事件名称校验后的提示语
      chosenElements: [], // 点击选中的同类元素
      chosenElement: null, // 点击元素
      contentRootPanel: null
    };
  },
  computed: {
    ...mapState({
      currentApp(state) {
        return state.bizSys.currentApp;
      },
      eventList(state) {
        return state.bizVisualizer.eventList;
      }
    }),
    existEventIds() {
      return this.eventList.map(event =>
        event.orderIndex
      );
    },
    sceneStyle() {
      return {
        width: `${this.sceneRect.width}px`,
        height: `${this.sceneRect.height}px`
      };
    }
  },
  mounted() {
    this.initSocket()
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    this.onClose(true);
  },
  methods: {
    initSocket() {
      console.log('init socket')
      socket = new WebSocket(
        `${this.socketUrl}?ctype=server&appkey=${this.currentApp.appKey}&platform=android`
      );
      socket.onmessage = this.onMessage;
      // socket.onclose = this.onClose;
      // socket.onerror = (err) => {
      //   console.error('on error')
      //   this.onClose()
      //   this.$nextTick(() => {
      //     this.initSocket();
      //   });
      // }
    },
    onMessage(event) {
      const msg = event.data;
      if (!msg) return;
      const res = JSON.parse(msg);
      if (res.code) {
        // 未连接
        console.log("尚未发现设备");
        this.status = this.statusMap.disconnect;
        this.connectMessage = res.reason
          ? res.reason.replace("client未连接", "尚未发现设备")
          : "client未连接";
      } else if (res.type) {
        switch (res.type) {
          case "quit": // 连接已断开
            console.log("手机端连接已断开");
            this.status = this.statusMap.disconnect;
            this.connectMessage = "手机端连接已断开";
            this.preHash = ""
            this.deviceInfo = null
            break;
          case "device_info_response": // 设备详情信息
            console.log("收到设备详情", res);
            this.deviceInfo = res.payload;
            this.requestSnapshot();
            this.snapshotInterval = setInterval(() => {
              this.requestSnapshot();
            }, 4000);
            break;
          case "enter": // 客户端连接成功
            if (res.role !== "client") break;
            console.log("客户端连接成功");
            this.status = this.statusMap.connecting;
            this.connectMessage = "设备检测成功，数据连接中...";
            // 发送设备详情请求
            socket.send('{"type": "device_info_request"}');
            break;
          case "snapshot_response": // 截屏信息
            console.log("收到截屏信息", res);
            this.status = this.statusMap.connected;
            if (!res.payload.activities.length) return;
            const newHash = md5(res.payload.activities[0].screenshot);
            this.$nextTick(() => {
              if (this.preHash !== newHash) {
                this.preHash = newHash;
                this.messageHandle(res);
              }
            });
            break;
          case "track_message": // 实时调试内容处理
            console.log("收到实时调试数据", res);
            this.debug(res);
            break;
        }
      }
    },
    /**
     * 请求页面数据
     */
    requestSnapshot() {
      socket.send(
        JSON.stringify({
          payload: {
            image_hash: this.preHash
          },
          type: "snapshot_request"
        })
      );
    },
    onClose(beforeDestroy) {
      console.log(`on close: beforeDestroy: ${beforeDestroy}`)
      clearInterval(this.snapshotInterval);
      this.status = this.statusMap.disconnect;
      this.connectMessage = "连接中断，请刷新页面尝试重新连接";
      if (!socket) return
      socket.close();
      socket.onmessage = null;
      socket.onclose = null;
      socket.onerror = null;
      socket = null;
      this.preHash = "";
      this.deviceInfo = null;
      if (beforeDestroy !== true) {
        this.$nextTick(() => {
          this.initSocket();
        });
      }
    },
    messageHandle(res) {
      console.log("处理页面快照");
      dataHandle.originPanelDatas = {}; // hashcode索引
      this.rootPanel = null;
      this.contentRootPanel = null;
      dataHandle.mpIdNameCount = {}; // mpIdName次数统计
      this.scale = res.payload.activities[0].scale;
      const screenShot = res.payload.activities[0].screenshot;
      const rootHashCode =
        res.payload.activities[0].serialized_objects.rootObject;
      let hashCodeMap = {}; // 存储hashcode与对象映射
      for (
        let i = 0;
        i < res.payload.activities[0].serialized_objects.objects.length;
        i++
      ) {
        const item = res.payload.activities[0].serialized_objects.objects[i];
        item.childViews = [];
        item.parent = null;
        item.orderIndex = "orderIndex";
        if (item.mp_id_name) {
          if (!dataHandle.mpIdNameCount[item.mp_id_name]) {
            dataHandle.mpIdNameCount[item.mp_id_name] = [];
          }
          dataHandle.mpIdNameCount[item.mp_id_name].push(item);
        }
        hashCodeMap[item.hashCode] = item;
        if (item.mp_id_name == "android:content") {
          this.contentRootPanel = item;
        }
        if (item.hashCode == rootHashCode) {
          this.rootPanel = util.clone(item);
        }
      }
      // 封装subviews
      for (const hashCode in hashCodeMap) {
        for (let i = 0; i < hashCodeMap[hashCode].subviews.length; i++) {
          let subviewCode = hashCodeMap[hashCode].subviews[i];
          let subview = hashCodeMap[subviewCode];
          hashCodeMap[hashCode].childViews.push(subview);
          if (!subview) {
            console.log("封装subviews,subview为空：", hashCode, hashCodeMap);
            continue;
          }
          subview.parent = hashCodeMap[hashCode];
        }
      }
      // 封装originPanelDatas
      for (const hashCode in hashCodeMap) {
        var item = hashCodeMap[hashCode];
        item.orderIndex = this.getOrderIndex(item.orderIndex, item);
        dataHandle.originPanelDatas[item.orderIndex] = item;
      }
      this.setBg(res.payload.activities[0].screenshot);
      function bfs(panel) {
        const queue = []
        if (panel) {
          queue.push(...panel.childViews)
          while(queue.length) {
            const item = queue.shift()
            if (item.hidden === 8 || item.visibility === 8) {
              const index = item.parent.childViews.findIndex((child) => child === item)
              item.parent.childViews.splice(index, 1)
            } else {
              queue.push(...item.childViews)
            }
          }
        }
      }
      bfs(this.contentRootPanel)
      this.drawElements(this.contentRootPanel);
      // dataHandle.data = dataHandle.getData(res);
      // dataHandle.setDataOrderIndex();
      // let rootObject_id = res.payload.serialized_objects.rootObject;
      // let contentTree = dataHandle.getItemById(rootObject_id);
      // dataHandle.getControllerTree(contentTree);
      // dataHandle.getDataTree(contentTree);
      // this.drawElements(contentTree);
    },
    getOrderIndex(orderIndex, panel) {
      // 处理匿名类
      if (!panel.classes[0]) {
        console.log("疑似匿名类", panel);
        return orderIndex;
      }
      const className = panel.classes[0].split(".");
      orderIndex += "_" + className[className.length - 1];
      if (panel.parent) {
        orderIndex += "_" + dataHandle.indexOfParent(panel);
        return this.getOrderIndex(orderIndex, panel.parent);
      }
      return orderIndex;
    },
    /**
     * 显示背景图
     */
    setBg(screenshot) {
      this.bgImgSrc = "data:image/png;base64," + screenshot;
      const rect = {
        width: this.rootPanel.width,
        height: this.rootPanel.height
      };
      const containerHeight = this.$refs.center.getBoundingClientRect().height;
      const scale = (this.scale = containerHeight / rect.height);
      this.sceneRect = {
        height: rect.height * scale + 1,
        width: rect.width * scale
      };
      setTimeout(() => { // 画面抖动一下，避免图片渲染不出来
        this.sceneRect = {
          height: rect.height * scale,
          width: rect.width * scale
        };
      })
    },
    /**
     * 渲染元素树，即把页面中所有元素都渲染出来
     */
    drawElements(elementTree) {
      this.clickableElements = [];
      this.drawElement(elementTree);
    },
    getElementRect(element) {
      const position = dataHandle.getPosition(element);
      const rect = {
        width: element.width * this.scale,
        height: element.height * this.scale,
        top: position.top * this.scale,
        left: position.left * this.scale
      };
      return rect;
    },
    drawElement(element) {
      if (dataHandle.isClickable(element)) {
        const rect = this.getElementRect(element);
        this.clickableElements.push({
          element,
          style: {
            top: rect.top + "px",
            left: rect.left + "px",
            width: rect.width + "px",
            height: rect.height + "px"
          }
        });
      }
      element.childViews.forEach(child => {
        this.drawElement(child);
      });
    },
    onClickElement(element) {
      if (this.existEventIds.includes(element.orderIndex)) return;
      this.chosenElements = dataHandle.choosePanels(element);
      this.chosenElement = element;
      this.showAddDialog = true;
    },
    async onAddEvent() {
      if (!this.$refs.eventName.validate()) {
        this.$refs.addDialog.$data.showLoading = false
        return
      }
      const nameInput = this.$refs.eventName;
      try {
        const nameValid = await this.$store.dispatch(
          actions.visualizer.checkEventName,
          {
            appid: this.appId,
            eName: this.eventName
          }
        );
        if (!nameValid) {
          this.nameTip = "事件名称已存在";
          nameInput.invalid = true;
          nameInput.$refs.tip.show();
          this.$refs.addDialog.$data.showLoading = false
        } else {
          nameInput.invalid = false;
          nameInput.$refs.tip.hide();
        }
      } catch (e) {
        nameInput.invalid = true;
        this.nameTip = "事件名称校验失败";
        nameInput.$refs.tip.show();
        this.$refs.addDialog.$data.showLoading = false
      }
      this.$store.dispatch(
        actions.visualizer.addEvent,
        await this.getEventData()
      );
      this.eventName = "";
      this.showAddDialog = false;
    },
    nameValidator(name) {
      if (!name || !/\S+/.test(name)) {
        this.nameTip = "事件名称不能为空";
        return false;
      }
      let nameExist = false;
      this.eventList.forEach(event => {
        if (event.event_name === name) {
          nameExist = true;
        }
      });
      if (nameExist) {
        this.nameTip = "事件名称已存在";
        return false;
      }
      return true;
    },
    async getEventData() {
      const overview = await this.getOverview();
      const events = {
        //事件列表
        type: "event_binding_request",
        payload: {
          events: []
        }
      };
      const event = {
        event_name: this.eventName,
        event_type: "click",
        orderIndex: this.chosenElement.orderIndex,
        device_type: "Android",
        path: [],
        status: "add",
        screenshot: overview,
        screenshot_url: ""
      };
      const deviceInfo = this.deviceInfo;
      for (const prop in deviceInfo) {
        event[prop] = deviceInfo[prop];
      }
      this.getPath(event.path, this.chosenElement);
      event.path.reverse();
      events.payload.events.push(event);
      return event;
    },
    getIndex(panel) {
      if (panel.mp_id_name) {
        return 0;
      }
      let parent = panel.parent;
      let index = 0;
      for (let i = 0; i < parent.childViews.length; i++) {
        if (parent.childViews[i].hashCode == panel.hashCode) break;
        if (parent.childViews[i].classes[0] == panel.classes[0]) index++;
      }
      return index;
    },
    getPath(path, panel) {
      let element = {
        index: this.getIndex(panel)
      };
      if (panel.orderIndex == this.contentRootPanel.orderIndex) {
        element = {
          index: 0,
          prefix: "shortest",
          id: panel.id
        };
        path.push(element);
        return;
      } else if (panel.mp_id_name) {
        element.mp_id_name = panel.mp_id_name;
      } else if (panel.classes && panel.classes.length) {
        element.view_class = panel.classes[0];
      }
      if (
        path.length >= 1 &&
        dataHandle.isKindOfClass(panel, dataHandle.blackList)
      ) {
        var pathItem = path[path.length - 1];
        delete pathItem.index;
        path[path.length - 1] = pathItem;
      }
      path.push(element);
      if (panel.parent) {
        this.getPath(path, panel.parent);
      }
      return path;
    },
    getControlEvent() {
      const action = dataHandle.actions;
      for (const key in action) {
        if (action.hasOwnProperty(key)) {
          for (let i = 0; i < this.chosenElement.class.length; i++) {
            if (action[key].includes(this.chosenElement.class[i])) {
              return parseInt(key);
            }
          }
        }
      }
      return null;
    },
    async getOverview() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");
      await this.resetCanvas(context);
      this.chosenElements.forEach(element => {
        const elementRect = this.getElementRect(element);
        context.fillStyle = "rgba(248, 107, 79, 0.7)";
        context.strokeStyle = "#fff";
        context.lineWidth = 2;
        context.beginPath();
        context.rect(
          elementRect.left,
          elementRect.top,
          elementRect.width,
          elementRect.height
        );
        context.fill();
        context.stroke();
        context.closePath();
      });
      return canvas.toDataURL();
    },
    resetCanvas(context) {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
          context.fillStyle = "blue";
          context.beginPath();
          context.rect(0, 0, this.sceneRect.width, this.sceneRect.height);
          context.closePath();
          context.drawImage(
            img,
            0,
            0,
            this.sceneRect.width,
            this.sceneRect.height
          );
          resolve();
        };
        img.src = this.bgImgSrc;
      });
    },
    debug(res) {
      this.debugLogs.push({
        name: res.payload.event_name,
        id: util.guid()
      });
      if (!this.logInterval) {
        this.logInterval = setInterval(() => {
          if (this.debugLogs.length) {
            this.debugLogs.shift();
          } else {
            clearInterval(this.logInterval);
            this.logInterval = null;
          }
        }, 2000);
      }
    },
    sendMsg(msg) {
      socket.send(msg);
    }
  }
};
</script>
<style lang="sass">
@import '../iosVisualizer/styles/index'
</style>
